import React from "react";
import { ReactComponent as EditIcon } from "../../assets/icons/management/edit.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/management/info.svg";
import { IOrder, OrderStatus } from "../../types/order.type";
import { formatDate, formatTime } from "../../utils/formatDate";
import PaymentStatusComponent from "../PaymentStatus/PaymentStatus";
import styles from "./styles.module.scss";

interface Props {
  orders: IOrder[];
  callBackInfo: (bool: boolean) => void;
  callBackEdit: (user: IOrder) => void;
}

const OrderTable: React.FC<Props> = (props) => {
  return (
    <table className={styles.customTable}>
      <thead>
        <tr>
          <th>Дата</th>
          <th>Інвойс</th>
          <th>Контактна інформація</th>
          <th>Замовлення</th>
          <th>Статус</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {props.orders &&
          props.orders.map((user, index) => (
            <tr key={user.id}>
              <td>
                <div className={styles.userInfo}>
                  <div className={styles.dateContainer}>
                    <span>{formatDate(user.createdAt)}</span>
                    <span>{formatTime(user.createdAt)}</span>
                  </div>
                </div>
              </td>
              <td className={styles.role}>
                {user.invoice ? (
                  <span className={styles.invoiceCell}>{user.invoice}</span>
                ) : (
                  <span className={styles.emptyCell}>—</span>
                )}
              </td>
              <td className={styles.role}>
                <div className={styles.nameContainer}>
                  <span className={styles.name}>{user.client.fullName}</span>
                  <span className={styles.email}>{user.client.phone}</span>

                  <span className={styles.email}>{user.client.email}</span>
                </div>
              </td>
              <td className={styles.role}>
                {user.items.map((item) => (
                  <div className={styles.nameContainer}>
                    <span className={styles.email}>
                      {item.product.name} - {item.quantity}
                    </span>
                  </div>
                ))}
              </td>
              <td>
                <PaymentStatusComponent status={user.status} />
              </td>
              <td>
                <div className={styles.actions}>
                  <button
                    type="button"
                    className={styles.editBtn}
                    title={
                      user.status === OrderStatus.PAID
                        ? "Списання зі складу"
                        : "Редагувати інвойс і дату"
                    }
                    aria-label={
                      user.status === OrderStatus.PAID
                        ? "Списання зі складу"
                        : "Редагувати замовлення"
                    }
                    onClick={() => {
                      if (user.status === OrderStatus.PAID) {
                        props.callBackInfo(false);
                        props.callBackEdit(user);
                      } else {
                        props.callBackInfo(true);
                        props.callBackEdit(user);
                      }
                    }}
                  >
                    <EditIcon />
                  </button>
                  <button
                    type="button"
                    className={styles.infoBtn}
                    title="Деталі замовлення"
                    aria-label="Деталі замовлення"
                    onClick={() => {
                      props.callBackInfo(true);
                      props.callBackEdit(user);
                    }}
                  >
                    <InfoIcon />
                  </button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

export default OrderTable;
